export default __webpack_public_path__ + "static/media/privacy.833cfcde.md";